import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToLocal'
})
export class UtcToLocalPipe implements PipeTransform {

  transform(value: Date, format: string): String {
    let offset = value.getTimezoneOffset();
             // console.log('offset', value, value.getMinutes());
            // let d = new Date(value.setMinutes(value.getMinutes() - offset));
            let str = value.toLocaleDateString() + ' ' + value.toLocaleTimeString();
            // console.log('offset', value, d, str);
            return str;
  }

}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/pipes/utc-to-local.pipe.ts